import { useState, useEffect } from 'react';
import { expertDashboardApi } from '../../api/expertDashboardApis/expert-dashboard.api';
// 🟢 Import the new ledger API
import { ledgerApi } from '../../api/paymentApis/ledger.api'; 
import { toast } from 'sonner';

export const useExpertDashboard = () => {
  const [dashboardData, setDashboardData] = useState<any>(null);
  // 🟢 State to hold the earnings/transactions data
  const [earningsData, setEarningsData] = useState<any>(null); 
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // 🟢 FIXED: Check for both camelCase and snake_case variations
      const expertCode = localStorage.getItem('expertCode') || localStorage.getItem('expert_code');

      // 🟢 Fetch BOTH home data and default (7 days) earnings at the exact same time
      const [homeData, ledgerData] = await Promise.all([
        expertDashboardApi.getHomeData(),
        expertCode ? ledgerApi.getExpertEarnings(expertCode, '7days') : Promise.resolve(null)
      ]);

      // 🐛 DEBUG LOG 1: See exactly what the API returned before it goes into state
     

      setDashboardData(homeData);
      setEarningsData(ledgerData);

    } catch (err: any) {
      console.error('Failed to load dashboard data:', err);
      
      // 🟢 FIXED: Check for 403 (Suspended/Rejected)
      if (err.response?.status === 403) {
        // 1. Show the toast immediately
        toast.error(err.response?.data?.message || 'Your account is suspended or rejected.');
        
        // 2. Clear their local storage (Removed access token per your instruction)
        localStorage.removeItem('expertCode');
        localStorage.removeItem('expert_code');
        localStorage.removeItem('expertName'); // Clearing the stored name
        
        // 3. WAIT 3 seconds for the user to read the toast, THEN redirect 
        setTimeout(() => {
          window.location.href = '/expert-login'; 
        }, 2000);
        
        return;
      }

      const errorMessage = err.response?.data?.message || 'Failed to load dashboard stats';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // 🟢 Dedicated function so your frontend buttons can change the date filter!
  const fetchFilteredEarnings = async (filter: string, startDate?: string, endDate?: string) => {
    // 🟢 FIXED: Check for both camelCase and snake_case variations here too!
    const expertCode = localStorage.getItem('expertCode') || localStorage.getItem('expert_code');
    if (!expertCode) return;

    try {
      const data = await ledgerApi.getExpertEarnings(expertCode, filter, startDate, endDate);
      setEarningsData(data); // Instantly updates the graph/table on your screen
    } catch (err) {
      console.error('Failed to fetch filtered earnings:', err);
      toast.error('Failed to filter earnings');
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  // 🐛 DEBUG LOG 2: See what the hook is actually returning to your components
 

  return { 
    // Existing returns
    dashboardData, 
    earningsData, 
    loading, 
    error, 
    refetch: fetchDashboardData,
    fetchFilteredEarnings,
    
    // 🚀 NEW: Exporting the booleans and wallet data directly!
    walletBalance: dashboardData?.wallet_balance || 0,
    allTimeEarnings: dashboardData?.all_time_earnings || 0,
    totalRedeemed: dashboardData?.total_redeemed || 0,
    isVerified: dashboardData?.is_payment_document_verified === true,
    isPayoutFrozen: dashboardData?.is_payout_frozen === true
  };
};